import { Minus, Plus } from 'lucide-react'
import React from 'react'

import { cn } from '@/modules/shared/lib/utils'

export type InputNumberProps = React.InputHTMLAttributes<HTMLInputElement> & {
  rate?: number
}

const InputNumber = React.forwardRef<HTMLInputElement, InputNumberProps>(
  ({ rate = 1, className, ...props }, ref) => {
    const increment = (
      e:
        | React.MouseEvent<HTMLButtonElement, MouseEvent>
        | React.KeyboardEvent<HTMLButtonElement>,
    ) => {
      e.preventDefault()
      const input = document.getElementById(props.id) as HTMLInputElement
      let value = Number.parseInt(input.value)
      if (Number.isNaN(value)) {
        value = 0
      }
      props.onChange?.({
        target: {
          value: (value + rate).toString(),
        },
      } as React.ChangeEvent<HTMLInputElement>)
    }

    const decrement = (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()
      const input = document.getElementById(props.id) as HTMLInputElement
      const value = Number.parseInt(input.value)

      if (value <= 0) {
        return
      }
      props.onChange?.({
        target: {
          value: (value - rate).toString(),
        },
      } as React.ChangeEvent<HTMLInputElement>)
    }
    return (
      <div
        className={cn(
          'flex flex-1 w-full h-12 p-1 items-center rounded-md border border-input bg-white px-3 text-md ring-offset-background focus-within:ring-1 focus-within:ring-ring focus-within:ring-offset-2',
          className,
        )}
      >
        <button type="button" className="cursor-pointer" onClick={decrement}>
          <Minus size={20} className="text-gray-500 dark:text-white" />
        </button>
        <input
          {...props}
          onClick={(e) => {
            const inputElement = e.target as HTMLInputElement
            inputElement.select()
          }}
          type="number"
          ref={ref}
          className="w-full mr-2 placeholder:text-muted-foreground focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 text-center"
        />
        <button
          type="button"
          onKeyUp={(e) => {
            if (e.key === 'Enter') {
              increment(e)
            }
          }}
          className="cursor-pointer"
          onClick={increment}
        >
          <Plus size={20} className=" text-gray-500 dark:text-white" />
        </button>
      </div>
    )
  },
)

InputNumber.displayName = 'InputNumber'

export { InputNumber }
